<template>
  <div id="organization_logo" v-if="organizationInfo && organizationInfo.logo">
    <img :src="organizationInfo.logo" :title="organizationInfo.name"/>
  </div>
</template>

<script>
export default {
  name: "OrganizationLogo",
  props:{
    organizationInfo: {type: Object, default: null},
  }
}
</script>

<style lang="less" >
@import "../../assets/common/OrganizationLogo.less";
</style>